/* yt-collection.js — filters and sort for collection pages (29 Sep 2026).
   Client-side over the cards' data attributes: tick boxes OR within a
   group, AND across groups; sort by rank, price or name. The phone drawer
   holds a second copy of the controls, kept in step with the desktop
   ones by name/value. */
(function () {
  'use strict';
  document.querySelectorAll('[data-ytcl]').forEach(function (root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ytcl-card]'));
    var grid = root.querySelector('[data-ytcl-grid]');
    var counts = root.querySelectorAll('[data-ytcl-count]');
    var empty = root.querySelector('[data-ytcl-empty]');
    var badge = root.querySelector('[data-ytcl-badge]');
    var clears = root.querySelectorAll('[data-ytcl-clear]');
    var boxes = Array.prototype.slice.call(root.querySelectorAll('input[type="checkbox"][name]'));
    var sorts = Array.prototype.slice.call(root.querySelectorAll('[data-ytcl-sort]'));
    var drawer = root.querySelector('[data-ytcl-drawer]');
    var opener = root.querySelector('[data-ytcl-open]');
    // Search mode (7 Oct 2026): every word typed must appear in the card's
    // search terms (title, tin name, line, category, goals, ingredients);
    // a trailing "s" is forgiven either way so "vitamins" finds "vitamin".
    var query = (root.getAttribute('data-ytcl-query') || '').toLowerCase().replace(/[^a-z0-9+\- ]/g, ' ').trim();
    var tokens = query ? query.split(/\s+/).filter(Boolean) : [];
    function matchesQuery(c) {
      if (!tokens.length) return true;
      var hay = ' ' + (c.getAttribute('data-search') || '').toLowerCase() + ' ';
      return tokens.every(function (t) {
        var stem = t.length > 3 && t.slice(-1) === 's' ? t.slice(0, -1) : t;
        return hay.indexOf(t) !== -1 || hay.indexOf(stem) !== -1;
      });
    }

    function selected(name) {
      var out = {};
      boxes.forEach(function (b) { if (b.name === name && b.checked) out[b.value] = true; });
      return Object.keys(out);
    }
    function apply() {
      var cats = selected('cat'), goals = selected('goal');
      var shown = 0;
      cards.forEach(function (c) {
        var okCat = !cats.length || cats.indexOf(c.getAttribute('data-cat')) !== -1;
        var g = c.getAttribute('data-goals') || '';
        var okGoal = !goals.length || goals.some(function (x) { return g.indexOf('|' + x + '|') !== -1; });
        var ok = okCat && okGoal && matchesQuery(c);
        c.classList.toggle('is-hidden', !ok);
        if (ok) shown += 1;
      });
      counts.forEach(function (el) { el.textContent = String(shown); });
      if (empty) empty.hidden = shown > 0;
      var n = cats.length + goals.length;
      if (badge) { badge.hidden = n === 0; badge.textContent = String(n); }
      clears.forEach(function (b) { if (b.hasAttribute('hidden') || b.classList.contains('ytcl-clear')) b.hidden = n === 0; });
    }
    function sortBy(mode) {
      var arr = cards.slice();
      var num = function (c, a) { return Number(c.getAttribute(a)) || 0; };
      arr.sort(function (a, b) {
        if (mode === 'price-asc') return num(a, 'data-price') - num(b, 'data-price');
        if (mode === 'price-desc') return num(b, 'data-price') - num(a, 'data-price');
        if (mode === 'name') return (a.getAttribute('data-name') || '').localeCompare(b.getAttribute('data-name') || '', 'en-GB');
        return num(a, 'data-rank') - num(b, 'data-rank');
      });
      arr.forEach(function (c) { grid.appendChild(c); });
      sorts.forEach(function (s) { if (s.value !== mode) s.value = mode; });
      if (window.ytTrack) { try { ytTrack('collection_sorted', { mode: mode }); } catch (_e) {} }
    }
    // Mirror a tick between the desktop column and the drawer.
    boxes.forEach(function (b) {
      b.addEventListener('change', function () {
        boxes.forEach(function (o) { if (o !== b && o.name === b.name && o.value === b.value) o.checked = b.checked; });
        apply();
        if (window.ytTrack && b.checked) { try { ytTrack('collection_filtered', { group: b.name, value: b.value }); } catch (_e) {} }
      });
    });
    sorts.forEach(function (s) { s.addEventListener('change', function () { sortBy(s.value); }); });
    clears.forEach(function (b) { b.addEventListener('click', function () { boxes.forEach(function (o) { o.checked = false; }); apply(); }); });
    root.querySelectorAll('[data-ytcl-toggle]').forEach(function (h) {
      h.addEventListener('click', function () { h.setAttribute('aria-expanded', h.getAttribute('aria-expanded') === 'false' ? 'true' : 'false'); });
    });
    function openDrawer() { if (!drawer) return; drawer.hidden = false; document.body.classList.add('ytcl-lock'); opener && opener.setAttribute('aria-expanded', 'true'); }
    function closeDrawer() { if (!drawer) return; drawer.hidden = true; document.body.classList.remove('ytcl-lock'); opener && opener.setAttribute('aria-expanded', 'false'); }
    if (opener) opener.addEventListener('click', openDrawer);
    root.querySelectorAll('[data-ytcl-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    // ?goal=Sleep or ?cat=Menopause pre-ticks a filter (ads, links from goal pages).
    var q = new URLSearchParams(window.location.search);
    ['cat', 'goal'].forEach(function (name) {
      (q.get(name) || '').split(',').forEach(function (v) {
        boxes.forEach(function (b) { if (b.name === name && b.value.toLowerCase() === v.trim().toLowerCase()) b.checked = true; });
      });
    });
    apply();
  });
})();
